import { render, staticRenderFns } from "./OrderFlow.vue?vue&type=template&id=01442246&"
import script from "./OrderFlow.vue?vue&type=script&lang=js&"
export * from "./OrderFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports